import React from "react";
import { useRecoilValue } from "recoil";
import FnolViewer from "components/FnolViewer";
import { fnolQuestionSetStructureState, fnolQuestionSetState } from "atoms/fnolQuestionSetState.atom";
import { userState } from "atoms/userState.atom";
import { Box, Typography, useTheme } from "@mui/material";
import Header from "components/Header";
import DecorativeImage from "Images/DecorativeImage.svg";
import { useSelector } from "react-redux";
import { selectDecorativeImage } from "slices/customerThemeSlice";

const TakingFnolForm = () => {
  const fnolQuestionSetStructure = useRecoilValue(fnolQuestionSetStructureState);
  const fnolQuestionSet = useRecoilValue(fnolQuestionSetState);
  const user = useRecoilValue(userState);
  const theme = useTheme();
  const dynamicDecorativeImage = useSelector(selectDecorativeImage) || DecorativeImage;

  return (
    <>
      <Header />
      <Box
        component="img"
        sx={{
          content: `url(${dynamicDecorativeImage})`,
          display: { xs: "none", lg: "block" },
          height: "144px",
          position: "absolute",
          top: "24px",
          left: 0,
        }}
      />
      <Box
        sx={{
          border: `2px solid ${theme.palette.grey.main}`,
          borderRadius: 4,
          my: { xs: 3, sm: 5, lg: 7 },
          p: 4,
          flex: 1,
        }}
      >
        <Typography variant="h2">Please Answer The Following Questions</Typography>
        <Typography variant="p" sx={{ display: "inline-block", mt: 1 }}>
          Until you click "Submit Form" the information you have entered will not be saved. Do not refresh the page. All
          fields highlighted in red are mandatory fields and must be completed to submit the report.
        </Typography>
        <FnolViewer
          fnolQuestionSetStructureState={fnolQuestionSetStructure}
          fnolQuestionSet={fnolQuestionSet}
          userId={user.id}
        />
      </Box>
    </>
  );
};

export default TakingFnolForm;
